import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { OnboardingPageLandingEvent } from '../models/events/onboardingPageLandingEvent.model';
import { environment } from '../../environments/environment';
import { OnboardingPageSubmitButtonClickedEvent } from '../models/events/onboardingPageSubmitButtonClickedEvent.model';

import { ClientConfigService } from './client-config.service';

@Injectable({
  providedIn: 'root'
})
export class EventsService {
  private httpClient = inject(HttpClient);
  private clientConfigService = inject(ClientConfigService);

  private postEvent(endpoint: string, eventObj: any) {
    const customHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set(
        'Ocp-Apim-Subscription-Key',
        environment.apiManagement.subscriptionKey
      );

    eventObj.brokerId = this.clientConfigService.getBrokerId();

    this.httpClient
      .post(
        `${environment.apiManagement.address}${endpoint}`,
        eventObj,
        { headers: customHeaders }
      )
      .subscribe({
        next: (res) => console.log(res),
        error: (error) => console.log(error)
      });
  }

  onboardingLandingPageEvent(landingPageEvent: OnboardingPageLandingEvent) {
    this.postEvent('newonboardingpageviewevent', landingPageEvent);
  }

  SubmitDocument(
    uploadDocumentEvent: OnboardingPageSubmitButtonClickedEvent
  ): void {
    this.postEvent('newuploaddocumentevent', uploadDocumentEvent);
  }
}
